import { observer } from "mobx-react";
import { DefaultModalLayout } from "../../../../../components/modal/layouts/default-modal-layout";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import './rma-resolve-errors-modal.scss';
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import { Button } from "../../../../../components/inputs/button/button";
import { IRmaAction } from "../../stores/rma-page-store";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";


interface IProps {
    rmaAction: IRmaAction;
    onCloseClick: () => void;
}

const RmaResolveErrorsModal: React.FC<IProps> = observer(({ rmaAction, onCloseClick }) => {
    const actionStore = rmaAction.store;

    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-returns-rma-card';

    const onSubmit = () => {
        actionStore.submitAction(onCloseClick);
    };

    return (
        <DefaultModalLayout isCloseDisabled={true} onCloseClicked={() => {}}>
            <div className={'resolve-errors-action-modal-content'}>
                <FontBody1 color={FONT_COLOR.NEUTRAL3}>{ getTranslation(rmaAction.name, 'dashboard-resolve-issue-popup') }</FontBody1>
                <FontBody1 color={FONT_COLOR.PRIMARY3}>{ getTranslation(rmaAction.descriptionTranslationKey, scope) }</FontBody1>

                <div className="resolve-errors-action-modal-buttons">
                    <Button text={getTranslation('DISMISS', 'dashboard-resolve-issue-popup') } onClick={onCloseClick} variant={BUTTON_VARIANTS.Tertiary} disabled={actionStore.isProcessing} />
                    <Button text={getTranslation(rmaAction.buttonTextTranslationKey, scope)} onClick={onSubmit} variant={BUTTON_VARIANTS.Primary} isLoading={actionStore.isProcessing} hasLoader={true} />
                </div>
            </div> 
        </DefaultModalLayout>
    );
});

export default RmaResolveErrorsModal;